import { Component, Input, OnDestroy } from '@angular/core';
import { AuthenticationService as SDKAuthentication, TokenStorage } from '@adeo/ngx-kozikaza-api';
import { ToastrService } from '../../../shared/services/utilities/toastr.service';
import { environment } from '../../../../environments/environment';
import { createClient } from '@reachfive/identity-core';
import { Subscription } from 'rxjs';
import { DataLayerService } from '../../../shared/services/utilities/data-layer.service';

@Component({
  selector: 'app-social',
  templateUrl: './social.component.html',
  styleUrls: ['./social.component.scss']
})
export class SocialComponent implements OnDestroy {
  @Input() inline = false;
  @Input() gtm: string;
  @Input() align = 'left';
  @Input() mode: string;

  authSubscription: Subscription;
  provider: string;

  private client = createClient({
    domain: environment.REACHFIVE_DOMAIN,
    clientId: environment.REACHFIVE_CLIENT_ID_FIRST_PARTY,
    language: 'fr',
  });

  constructor(
    private toastrService: ToastrService,
    private sdkAuthenticationService: SDKAuthentication,
    private tokenStorage: TokenStorage,
    protected dataLayerService: DataLayerService
  ) {
    this.client.on('authenticated', (authResult: any) => {
      if (authResult && authResult.authorizationCode) {
        this.authSubscription = this.sdkAuthenticationService.authenticateWithProviderCode({
          code: authResult.authorizationCode,
          redirectUri: environment.REACHFIVE_REDIRECT_URI,
          clientId: environment.REACHFIVE_CLIENT_ID_FIRST_PARTY
        }).subscribe(
          () => {
            if (this.tokenStorage.token && this.tokenStorage.token.idTokenPayload && this.tokenStorage.token.idTokenPayload.newUser) {
              this.dataLayerService.sendEvent({
                event: 'createAccount',
                eventCategory: 'account',
                eventAction: 'create',
                eventLabel: this.dataLayerService.getCurrentContext() + '-' + this.provider
              });
            }
          }
        );
      }
    });
  }

  loginWithProvider(provider: string): any {
    const params: any = {
      redirectUri: environment.REACHFIVE_REDIRECT_URI,
      responseType: 'messenger_code',
      popupMode: true,
      useWebMessage: true,
      scope: environment.REACHFIVE_SCOPE
    };

    this.provider = provider;

    return this.client.loginWithSocialProvider(provider, params);
  }

  ngOnDestroy(): void {
    if (this.authSubscription && !this.authSubscription.closed) {
      this.authSubscription.unsubscribe();
    }
  }
}
